import {ReactElement, useContext} from "react";
import {CSVBoxButton} from "../../../../../components/csvbox/CSVBoxButton";
import {
    csvBoxExtractFilename,
    csvBoxExtractRows,
    csvBoxGeneralError,
    csvBoxHasError
} from "../../../../../global/csv_box_helpers";
import {Button} from "@zendeskgarden/react-buttons";
import {AuthContext} from "../../../../../contexts/AuthContext";
import {CustomCoADataItem, extractData} from "./custom-coa-common";

export interface UpdateCustomCoAValuesButtonProps {
    externalCoaId: string;
    data: (filename: string, uploaded: CustomCoADataItem[]) => void;
}

export function UpdateCustomCoAValuesButton(props: UpdateCustomCoAValuesButtonProps): ReactElement {
    const {user} = useContext(AuthContext);

    function handleData(data: unknown): void {
        const filename = csvBoxExtractFilename(data) || "";
        const rows = csvBoxExtractRows(data);
        if(rows === undefined) {
            csvBoxGeneralError("Custom CoA");
            return;
        }

        const extracted = extractData(rows);
        if(extracted.length === 0) {
            csvBoxGeneralError("Custom CoA");
            return;
        }

        props.data(filename, extracted);
    }

    return <CSVBoxButton
            licenseKey="JSTE3WQK7vJiCHw4X44pE3inbiHuBP"
            user={{
                userId: user?.id ?? "unknown",
                name: user?.firstName || user?.lastName ? `${user?.firstName || ""} ${user?.lastName || ""}` : "unknown",
                email: user?.email ?? "unknown",
                clientId: user?.clientId ?? "unknown",
                clientName: user?.clientName ?? "unknown",
            }}
            environment={{
                // TODO: Make base url environment variable.
                "base_url": process.env["REACT_APP_CSV_BOX_BASE_URL"],
                "external_coa_id": props.externalCoaId
            }}
            onImport={(result, data) => {
                if(!csvBoxHasError(result, data)) {
                    handleData(data);
                } else {
                    csvBoxGeneralError("Custom CoA");
                }
            }}
            render={(launch, isLoading) => {
                return <Button onClick={launch} disabled={isLoading && props.externalCoaId !== ""}>Upload Account Values</Button>;
            }}
    />;
}